/**
 * @Description This file contains all the API configuration for Compensation Structure module
 * @FileName apiConfig.js
 * @Author Jayanta Sarkhel - sarkhja
 * @CreatedOn 15 march, 2021 9.30
 * @IssueID
*/

import { environment } from '../../../common/util';

const envData = environment();
/**
 * Module specific API endpoint configuration.
 */
const apiConfig = {
  REPORT_LIST: {
    endpoint: `${envData.apiHost}/api/comphierarchy/list`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  PROD_SUMMARY_LIST: {
    endpoint: `${envData.apiHost}/api/productionsummary/list`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  PROD_SUMMARY_EXPORT: {
    endpoint: `${envData.apiHost}/api/productionsummary/export`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  BAL_SUMMARY_LIST: {
    endpoint: `${envData.apiHost}/api/balancesummary/list`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  BAL_SUMMARY_EXPORT: {
    endpoint: `${envData.apiHost}/api/balancesummary/export`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  CS_REPORT_LIST: {
    endpoint: `${envData.apiHost}/api/reportrepository/list`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  CS_REPORT_EXPORT: {
    endpoint: `${envData.apiHost}/api/reportrepository/export`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  // CSR_EXT
  CS_REPORT_LIST_EXT: {
    endpoint: `${envData.apiHost}/api/compensationstatementext/list`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  // Compenstion statements
  CS_REPORT_LIST_API: {
    endpoint: `${envData.apiHost}/api/compensationStatement/list`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  IAR_ACTIVITY_PERIOD_LOOKUP: {
    endpoint: `${envData.apiHost}/api/interactive/getActivityPeriod`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  IAR_COMP_TYPE_LIST: {
    endpoint: `${envData.apiHost}/api/interactive/getCompensationType`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  IAR_MSCodes_LIST: {
    endpoint: `${envData.apiHost}/api/interactive/getManulifeSellingCode`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  IAR_COMP_TYPE_HIER_LIST: {
    endpoint: `${envData.apiHost}/api/interactive/getProduct`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  GET_ALFESCO_DOCUMENT: {
    endpoint: `${envData.apiHost}/api/docmgmt/search?returnAsSingeldoc=true`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  GET_ALFESCO_DOCUMENT_B4: {
    endpoint: `${envData.apiHost}/api/docmgmt/search?returnAsSingeldoc=true`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  COMMISSION_FEED_DATA: {
    endpoint: `${envData.apiHost}/api/commissionfeed/getCommssionFeedValues`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  COMMISSION_GENERATE_REQUEST: {
    endpoint: `${envData.apiHost}/api/commissionfeed/generateCommFeed`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  COMMISSION_GENERATE_REQUEST_BATCH: {
    endpoint: `${envData.apiHost}/api/reportbatch/generatecompfeed`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  COMPENSATION_STATEMENT_DOWNLOAD: {
    endpoint: `${envData.apiHost}/api/docmgmt/search`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  COMPENSATION_STATEMENT_DOWNLOAD_POST: {
    endpoint: `${envData.apiHost}/api/docmgmt/search`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  GET_DB_SYSTEM_DATE: {
    endpoint: `${envData.apiHost}/api/docmgmt/getsystemdate`,
    type: 'GET',
    authorizationRequired: true,
    showLoading: true,
  },
  EXPORT_IAR_COMPTYPES: {
    endpoint: `${envData.apiHost}/api/interactive/getCompensationType/export`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  EXPORT_IAR_MSC: {
    endpoint: `${envData.apiHost}/api/interactive/getManulifeSellingCode/export`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  EXPORT_IAR_PRODUCT: {
    endpoint: `${envData.apiHost}/api/interactive/getProduct/export`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  SELF_SERVICE_CATEGORY: {
    endpoint: `${envData.apiHost}/api/selfservice/getCategory/@@locale`,
    type: 'GET',
    authorizationRequired: true,
    showLoading: true,
  },
  SELF_SERVICE_DATA_SOURCE: {
    endpoint: `${envData.apiHost}/api/selfservice/getDataSource`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  SELF_SERVICE_FIELD_MAPPING: {
    endpoint: `${envData.apiHost}/api/selfservice/getFieldMapping`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  SELF_SERVICE_LIST: {
    endpoint: `${envData.apiHost}/api/selfservice/list`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  SELF_SERVICE_TEMPLATE: {
    endpoint: `${envData.apiHost}/api/selfservice/template`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  SELF_SERVICE_TEMPLATE_SAVE: {
    endpoint: `${envData.apiHost}/api/selfservice`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  SELF_SERVICE_TEMPLATE_UPDATE: {
    endpoint: `${envData.apiHost}/api/selfservice`,
    type: 'PUT',
    authorizationRequired: true,
    showLoading: true,
  },
  SELF_SERVICE_TEMPLATE_DELETE: {
    endpoint: `${envData.apiHost}/api/selfservice`,
    type: 'DELETE ',
    authorizationRequired: true,
    showLoading: true,
  },
  REPORT_CENTER_LIST: {
    endpoint: `${envData.apiHost}/api/selfservice/templateList`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  GET_REPORT_CENTER_LIST_BYID: {
    endpoint: `${envData.apiHost}/api/selfservice/getTemplate`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  GET_SHARE_REPORT_TEMPLATE: {
    endpoint: `${envData.apiHost}/api/selfservice/getShareInfo`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  SAVE_SHARE_REPORT_TEMPLATE: {
    endpoint: `${envData.apiHost}/api/selfservice/saveShareInfo`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  VALIDATE_SHARE_REPORT_TEMPLATE: {
    endpoint: `${envData.apiHost}/api/selfservice/validateShareInfo`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  DELETE_REPORT_TEMPLATE: {
    endpoint: `${envData.apiHost}/api/selfservice`,
    type: 'DELETE',
    authorizationRequired: true,
    showLoading: true,
  },
  GENERATE_REPORT_TEMPLATE: {
    endpoint: `${envData.apiHost}/api/selfservice/generateReport`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  GENERATED_REPORT_LIST: {
    endpoint: `${envData.apiHost}/api/generatedreport/list`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  GENERATED_REPORT_DOWNLOAD: {
    endpoint: `${envData.apiHost}/api/selfservice/generatedReport/download`,
    type: 'DOWNLOAD',
    authorizationRequired: true,
    showLoading: true,
  },
  GENERATED_REPORT_SHARE: {
    endpoint: `${envData.apiHost}/api/selfservice/generatedreport/share`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
  GENERATED_REPORT_DELETE: {
    endpoint: `${envData.apiHost}/api/generatedreport`,
    type: 'DELETE',
    authorizationRequired: true,
    showLoading: true,
  },
  GET_REPORT_SCHEDULE_INFO: {
    endpoint: `${envData.apiHost}/api/selfservice/scheduleInfo/@@templateId`,
    type: 'GET',
    authorizationRequired: true,
    showLoading: true,
  },
  SAVE_REPORT_SCHEDULE_INFO: {
    endpoint: `${envData.apiHost}/api/selfservice/scheduleInfo`,
    type: 'POST',
    authorizationRequired: true,
    showLoading: true,
  },
};
export default apiConfig;
